import { ChevronRightGray400Icon, PencilGray400Icon, TrashCanErrorIcon } from '@assets/iconComponents';
import {
  CollectionUpsertModal,
  Frame,
  GuideModal,
  ImageListItemComponent,
  ImageModal,
  MenuTop,
  Text
} from '@components';
import { useCollectionImageList } from '@hooks';
import { Button } from '@mui/material';
import { colorSet } from '@theme';
import { IImageListItem } from '@types';

const CollectionImageListPage = () => {
  const {
    handleBreadCrumbClick,
    collectionIdPathParam,
    initialCollectionName,
    data,
    flattenCollectionImageList,
    outputBottomRef,
    handleImageClick,
    handleImageModalClose,
    handleImageUseButtonClick,
    isCollectionUpsertModalVisible,
    handleCollectionUpsertModalOpen,
    handleCollectionUpsertModalClose,
    isCollectionDeleteModalVisible,
    handleCollectionDeleteModalOpen,
    handleCollectionDeleteModalClose,
    handleCollectionDeleteConfirmClick
  } = useCollectionImageList();

  const gap = 4;
  const itemNumberPerRow = 7;
  const sumOfHorizontalGaps = gap * (itemNumberPerRow - 1);
  const itemSize = `calc((100% - ${sumOfHorizontalGaps}px) / ${itemNumberPerRow})`;

  return (
    <>
      <MenuTop />

      <Frame width="100%" padding="24px 40px 96px 40px">
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
            marginBottom: '20px'
          }}
        >
          <div>
            <div
              onClick={handleBreadCrumbClick}
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                marginBottom: '4px',
                cursor: 'pointer'
              }}
            >
              <Text variant="body1" color="primary" marginRight="10px">
                컬렉션
              </Text>
              <ChevronRightGray400Icon style={{ width: 16, height: 16 }} />
            </div>
            <Text variant="h2" fontWeight="bold">
              {initialCollectionName}
            </Text>
          </div>
          <div style={{ display: 'flex', flexDirection: 'row', gap: 12 }}>
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => {
                handleCollectionUpsertModalOpen();
              }}
              sx={{ width: 84, height: 44 }}
            >
              <PencilGray400Icon style={{ width: 20, height: 20 }} />
            </Button>
            <Button
              variant="outlined"
              color="error"
              onClick={() => {
                handleCollectionDeleteModalOpen();
              }}
              sx={{ width: 84, height: 44 }}
            >
              <TrashCanErrorIcon style={{ width: 20, height: 20 }} />
            </Button>
          </div>
        </div>

        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: `${gap}px`,
            width: '100%',
            boxSizing: 'border-box'
          }}
        >
          {data &&
            flattenCollectionImageList().length > 0 &&
            flattenCollectionImageList().map((item: IImageListItem, index) => {
              return (
                <ImageListItemComponent
                  key={`${item.id}_${index}`}
                  item={item}
                  itemSize={itemSize}
                  onImageClick={handleImageClick}
                  onUseButtonClick={handleImageUseButtonClick}
                />
              );
            })}
        </div>
        <div ref={outputBottomRef} />

        {(!data || flattenCollectionImageList().length === 0) && (
          <div
            style={{
              height: '100px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <Text variant="body1" color={colorSet.gray500}>
              저장한 이미지가 없습니다.
            </Text>
          </div>
        )}
      </Frame>

      <ImageModal onClose={handleImageModalClose} onUseButtonClick={handleImageUseButtonClick} />

      <CollectionUpsertModal
        isVisible={isCollectionUpsertModalVisible}
        onClose={handleCollectionUpsertModalClose}
        targetCollectionId={Number(collectionIdPathParam)}
        initialCollectionName={initialCollectionName}
      />

      <GuideModal
        isVisible={isCollectionDeleteModalVisible}
        onClick={handleCollectionDeleteConfirmClick}
        onClose={handleCollectionDeleteModalClose}
        title={'컬렉션을 삭제하시겠습니까?'}
        content={'이 작업은 되돌릴 수 없습니다.'}
        buttonText="삭제하기"
        buttonVariant="contained"
        buttonCount={2}
      />
    </>
  );
};

export default CollectionImageListPage;
